import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Phone from '@material-ui/icons/Phone';
import Email from '@material-ui/icons/Email';
import Tooltip from '@material-ui/core/Tooltip';

const DatasetsConfig = props => {
  const { classes } = props;

  return {
    registros: {
      datosConfig: {
        titulo: 'dataTable.title',
        servicio: 'registro',
        url: 'registro'
      },
      datosSettings: {
        /*ruc: {
          label: 'RUC',
          sortable: true,
          filterable: true,
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.ruc ? item.ruc : ''}
            </TableCell>
          )
        },*/
        razonsocial: {
          label: 'dataTable.razonSocial',
          sortable: true,
          filterable: true,
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.razonsocial ? item.razonsocial : ''}
            </TableCell>
          )
        },
        telefono: {
          label: 'dataTable.phone',
          sortable: true,
          filterable: true,
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.telefono ? item.telefono : '-'}
            </TableCell>
          )
        },
        direccion: {
          label: 'dataTable.address',
          sortable: true,
          filterable: true,
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.direccion ? item.direccion : '-'}
            </TableCell>
          )
        },
        emailcorp: {
          label: 'dataTable.email',
          sortable: true,
          filterable: true,
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.emailcorp ? item.emailcorp : '-'}
            </TableCell>
          )
        },
        'registros.departamento.departamento': {
          label: 'dataTable.department',
          sortable: true,
          filterable: true,
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.registros && item.registros.length !== 0
                ? item.registros[0].departamento.departamento
                : '-'}
            </TableCell>
          )
        },
        'registros.ciudad.ciudad': {
          label: 'dataTable.city',
          sortable: true,
          filterable: true,
          type: 'string',
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.registros && item.registros.length !== 0
                ? item.registros[0].ciudad.ciudad
                : '-'}
            </TableCell>
          )
        },
        actions: {
          label: 'dataTable.actions',
          sortable: false,
          filterable: false,
          cellRendering: item => (
            <TableCell className={classes.tableCellAction}>
              <div style={{ display: 'flex', padding: 0 }}>
                {item.telefono && (
                  <a
                    target="_top"
                    rel="noopener noreferrer"
                    href={`tel:${item.telefono}`}
                    style={{ padding: '0 8px' }}
                  >
                    <Tooltip title="Llamar" placement="bottom">
                      <IconButton color="primary" size="small">
                        <Phone /> {/* icon */}
                      </IconButton>
                    </Tooltip>
                  </a>
                )}
                {item.emailcorp && (
                  <a
                    target="_top"
                    rel="noopener noreferrer"
                    href={`mailto:${item.emailcorp}`}
                    color="secondary"
                    style={{ padding: '0 8px' }}
                  >
                    <Tooltip title="Enviar correo" placement="bottom">
                      <IconButton color="secondary" size="small">
                        <Email /> {/* icon */}
                      </IconButton>
                    </Tooltip>
                  </a>
                )}
              </div>
            </TableCell>
          )
        }
      }
    }
  };
};

export default DatasetsConfig;
